export default __webpack_public_path__ + "static/media/icon-node-tipo-envio.2599782c.svg";